import { Component, Input } from '@angular/core'
import { closeJobSelectionDialog } from '../../../shared/utils/job-selection-dialog-utils'
import { PipelineType, SegmentationType } from '../../../shared/model/jobs'
import { JobApiService } from '../../../shared/services/job-api.service'
import { Observable } from 'rxjs'
import { StaticLayerConfig } from '../../../state/viewer/viewer.state'
import { Store } from '@ngrx/store'
import { selectImageLayers } from '../../../state/viewer/viewer.selectors'
import { ToasterService } from '../../../shared/services/toaster.service'
import { HttpErrorResponse } from '@angular/common/http'
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'app-segmentation-selection',
    templateUrl: './segmentation-selection.component.html',
    styleUrls: ['./segmentation-selection.component.scss'],
})
export class SegmentationSelectionComponent {
    @Input()
    siblingDatasets: string[] | never[]
    imageLayers$: Observable<StaticLayerConfig[]>
    selectedTargetLayer: StaticLayerConfig | null = null
    selectedNuclearLayer: StaticLayerConfig | null = null

    SegmentationTypeEnum = SegmentationType
    selectedSegmentation: SegmentationType | null = null
    submitted: boolean = false
    runBatchJob: boolean = false

    private readonly wikiUrl = environment.wikiUrl

    constructor(
        store: Store,
        private readonly jobApi: JobApiService,
        private readonly toaster: ToasterService
    ) {
        this.imageLayers$ = store.select(selectImageLayers)
    }

    get canStart(): boolean {
        return !!this.selectedTargetLayer && !!this.selectedSegmentation && !this.submitted
    }

    cancel(): void {
        closeJobSelectionDialog()
    }

    startJob(): void {
        if (!this.canStart) return
        this.submitted = true

        this.jobApi
            .startSegmentationJob({
                type: PipelineType.Segmentation,
                target: this.selectedTargetLayer!.name,
                nucleus: this.selectedNuclearLayer?.name,
                model: this.selectedSegmentation!,
                batch: this.runBatchJob,
            })
            .subscribe({
                next: () => closeJobSelectionDialog(),
                error: (err: HttpErrorResponse) => {
                    this.toaster.httpError(err, 'Error starting job')
                },
            })
    }

    chooseTargetLayer(layer: StaticLayerConfig): void {
        this.selectedTargetLayer = layer
    }
    chooseNucleusLayer(layer: StaticLayerConfig): void {
        this.selectedNuclearLayer = layer
    }

    goToWiki(): void {
        window.open(`${this.wikiUrl}home/Working_with_jobs#h-2-cell-segmentation`, '_blank')
    }
}
